// extracted by mini-css-extract-plugin
export default {"infoCard-container":"TotalEvent_infoCard-container__tEJND","svg-container":"TotalEvent_svg-container__Hl3XP","svg":"TotalEvent_svg__WgzJ3"};